// File: frontend/src/pages/AIAgents/components/KeyboardHint.js

import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ArrowLeft, ArrowRight, ArrowUp, ArrowDown, Keyboard } from 'lucide-react';
import styles from './KeyboardHint.module.css';

const KeyboardHint = () => {
  const [visible, setVisible] = useState(false);
  
  // Show hint after a short delay, hide after some time
  useEffect(() => {
    const showTimer = setTimeout(() => {
      setVisible(true);
    }, 2000);
    
    const hideTimer = setTimeout(() => {
      setVisible(false);
    }, 8000);
    
    return () => {
      clearTimeout(showTimer);
      clearTimeout(hideTimer);
    };
  }, []);
  
  return (
    <AnimatePresence>
      {visible && (
        <motion.div 
          className={styles.container}
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: 20 }}
          transition={{ duration: 0.3 }}
        >
          <div className={styles.icon}>
            <Keyboard size={16} />
          </div>
          <div className={styles.hints}>
            <div className={styles.hint}>
              <div className={styles.keys}>
                <span className={styles.key}><ArrowLeft size={12} /></span>
                <span className={styles.key}><ArrowRight size={12} /></span>
              </div>
              <span className={styles.label}>Navigate agents</span>
            </div>
            <div className={styles.hint}>
              <div className={styles.keys}>
                <span className={styles.key}><ArrowUp size={12} /></span>
                <span className={styles.key}><ArrowDown size={12} /></span>
              </div>
              <span className={styles.label}>Change categories</span>
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default KeyboardHint;